import styled from 'styled-components';

export const Wrap = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  background: ${props => (props.isClicker ? '#09276A' : '#fafafa')};
  color: ${props => (props.isClicker ? '#f1f1f1' : '#222')};
  min-height: 400px;
  padding: 56px 0;
  text-align: center;
  transition: background 0.3s, color 0.3s;

  .car-parts-background {
    --parts-far-blur: 1.5px;
    --parts-mid-blur: 1px;
    --parts-front-blur: 0.5px;
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
  }

  .car-part {
    --parallax-x: 0px;
    --parallax-y: 0px;
    position: absolute;
    width: auto;
    height: auto;
    max-width: none;
    object-fit: contain;
    transform: translate3d(var(--parallax-x), var(--parallax-y), 0);
    will-change: filter, transform;
    transition: filter 100ms linear;
  }

  .car-part--far {
    opacity: 0.1;
    filter: blur(var(--parts-far-blur));
  }

  .car-part--mid {
    opacity: 0.12;
    filter: blur(var(--parts-mid-blur));
  }

  .car-part--front {
    opacity: 0.15;
    filter: blur(var(--parts-front-blur));
  }

  .car-part--motor {
    top: -12%;
    left: 2%;
    width: clamp(180px, 20vw, 320px);
  }

  .car-part--painel {
    top: 4%;
    right: -5%;
    width: clamp(520px, 40vw, 680px);
    transform-origin: right center;
  }

  .car-part--pneu {
    right: 5%;
    bottom: -10%;
    width: clamp(150px, 17vw, 250px);
  }

  .car-part--banco {
    bottom: -18%;
    left: -2%;
    width: clamp(180px, 20vw, 300px);
  }

  .car-part--sport-banco {
    top: 30%;
    right: 5%;
    width: clamp(260px, 15vw, 320px);
  }

  .car-part--cambio {
    top: 8%;
    left: 39%;
    width: clamp(130px, 14vw, 210px);
  }

  .car-part--sport-cambio {
    right: 28%;
    bottom: 2%;
    width: clamp(120px, 13vw, 190px);
  }

  .container {
    position: relative;
    z-index: 1;
    width: 95%;
    max-width: 1300px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 63px;

    > div {
      margin: 0 auto;
      position: relative;
      background: ${props => (props.isClicker ? '#0E3182' : 'white')};
      padding: 40px 5vw;
      padding-top: 95px;
      border-radius: 15px;
      box-shadow: 0 18px 14px rgba(0, 0, 0, 0.2);
      max-width: 100%;
      transition: background 0.3s;

      > svg {
        position: absolute;
        top: -65px;
        left: 50%;
        transform: translateX(-50%);
        margin: 0 auto;
        display: inline-block;
      }

      > div {
        margin: 20px;

        button {
          min-width: 150px;
          height: auto;
          padding: 10px;
          border: ${props =>
            props.isClicker ? '2px solid #7AC943' : '2px solid transparent'};
          border-radius: 24px;
          background: #fff;
          cursor: pointer;
          margin: 50px 10px;
          transition: border 0.3s;

          img {
            height: 80px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 700px) {
    .car-part--motor,
    .car-part--sport-banco,
    .car-part--cambio,
    .car-part--sport-cambio {
      display: none;
    }

    .car-part--painel {
      top: 0;
      right: 0;
      width: 75vw;
    }

    .car-part--pneu {
      right: -10%;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .car-parts-background {
      display: none;
    }
  }
`;

export const H2 = styled.h2`
  position: relative;
  font-family: Fugaz One;
  font-style: normal;
  font-weight: normal;
  font-size: 52px;
  line-height: 68px;
  text-align: center;
  color: ${props => (props.isClicker ? '#ffffff' : '#0e3182')};
  transition: color 0.3s;

  /** Estilização para dispositivos móveis */
  @media screen and (max-width: 1060px) {
    display: inline-block;
    margin: 20px auto;
  }

  @media screen and (max-width: 540px) {
    display: inline-block;
    margin: 20px auto;
    font-size: 35px;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
`;

export const SwitchLabel = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${props =>
    props.active
      ? props.isClicker
        ? '#7AC943'
        : '#0e3182'
      : props.isClicker
      ? '#888'
      : '#ccc'};
  cursor: pointer;
  transition: color 0.3s;
`;

export const Switch = styled.div`
  position: relative;
  width: 60px;
  height: 34px;
  background-color: ${props => (props.isClicker ? '#7AC943' : '#ccc')};
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.3s;

  &::before {
    content: '';
    position: absolute;
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s;
    transform: ${props =>
      props.isClicker ? 'translateX(26px)' : 'translateX(0)'};
  }
`;
